import { gql } from '@apollo/client';
import { useFeatureFlag, Availability } from '@moda/portal-stanchions';
import { ProductMediaGalleryFragment } from '../../generated/types';

export const PRODUCT_MEDIA_GALLERY_VIDEOS_FRAGMENT = gql`
  fragment ProductMediaGalleryVideosFragment on Variant {
    availability
    trunkshowsData: limited_trunkshow_data {
      slug
    }
  }
`;

export const useProductMediaGalleryVideos = (variant: ProductMediaGalleryFragment) => {
  const videosEnabledForTrunkshow = useFeatureFlag(
    variant.availability === Availability.Trunkshow.toString() &&
      variant.trunkshowsData?.[0] != null
      ? `pdp-videos-${variant.trunkshowsData[0].slug}`
      : '',
    [{ default: true }, { if: false, then: false }]
  );

  return videosEnabledForTrunkshow ? variant.videos : [];
};
